import { h, Component } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";

import SoccerTracker from "./sports/soccer-tracker";
import IceHokeyTracker from "./sports/ice-hokey-tracker";
import BasketTracker from "./sports/basketball-tracker";
import TennisTracker from "./sports/tennis-tracker";

const sportTracker = {
	'/sport/1': (props) => <SoccerTracker {...props} />,
	'/sport/2': (props) => <IceHokeyTracker {...props} />,
	'/sport/7': (props) => <TennisTracker {...props} />,
	'/sport/10': (props) => <BasketTracker {...props} />,
};

export default class Tracker extends Component {
	render({ event, isMobile, ...props }) {
		if (!!sportTracker[event.sport]) {
			const DynamicTracker = sportTracker[event.sport];
			return (
				<DynamicTracker
					isMobile={isMobile}
					event={event}
					lastEventName={event.misc.tracker.name}
				/>
			);
		}
		return (
			<div style="text-align: center; padding: 20px;">
				<Trans>Widget is not available</Trans>
			</div>
		);
	}
}

